
const data = [
  {
    title: '生态构建概述',
    description: '通过对产品模式、盈利模式、运营模式的重新构建，采用各种创新元素帮助企业构建新的差异化竞争门槛。'
  },
  {
    title: '服务内容',
    description: '多元业务组合\n' +
      '企业生态圈设计\n' +
      '服务创新与转型\n' +
      '运营管理体系建设'
  },
  {
    title: '服务特点',
    description: '存量业务基于创新元素考虑激活和提升产品组合的利润水平；\n' +
      '寻求创新元素设计新的业务组合和设计新的利润模式。'
  }
];

export default data;


// WEBPACK FOOTER //
// ./src/routes/Service/config/ecology-build.js